import { buildPrompt } from '@/ai/utils/promptBuilder'
import { createUserMessage } from '@/ai/utils/promptUtils'
import { examples, getEventExample } from '@/ai/prompts/common/examples'
import { getCardTypeInstruction } from '@/ai/prompts/common/instructions'
import { getJsonArrayOutputFormatting } from '@/ai/prompts/common/formatting'

export const buildWorkflowCardsPrompt = ({ workflow, cardTypes }) => {
  const messages = []

  const promptSections = []
  const cardTypeInstructionsContent = []
  const cardTypeConsiderationContent = []

  cardTypes.forEach((cardType) => {
    if (cardType.generateWithAI) {
      cardTypeInstructionsContent.push(getCardTypeInstruction(cardType))
      cardTypeConsiderationContent.push(`${cardType.title}: Exactly one item`)
    }
  })

  promptSections.push({
    title: 'Request',
    content: 'For each step, add one item of each type from the following list:',
    spacingAfter: 0
  })

  promptSections.push({
    contentType: 'bullet',
    content: cardTypeInstructionsContent
  })

  promptSections.push({
    title: 'Very Important Consideration',
    content: [
      `It is crucial to ensure that the output contains exactly ${workflow.eventsJson.length} JSON objects
       (one for each event). Each JSON object must strictly adhere to the following structure and item count:`,
      ...cardTypeConsiderationContent
    ]
  })

  const formattingContent = `The resulting array must contain ${workflow.eventsJson.length} items.`

  const options = {
    shouldAddCards: true,
    shouldAddDataModels: false
  }

  const exampleData1 = {
    role: 'Role description',
    description: 'Created order',
    commandExample: examples.commandExampleCreateOrder
  }
  const exampleData2 = {
    role: 'Role description',
    description: 'Resolved issue',
    commandExample: examples.commandExampleDeliverOrder
  }

  const eventsExample = [
    getEventExample(exampleData1, cardTypes, null, options),
    getEventExample(exampleData2, cardTypes, null, options)
  ]

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonArrayOutputFormatting(JSON.stringify(eventsExample), formattingContent)

  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
